import React from "react";
import { Link } from "react-router-dom";
import './Home.css';

export function Home() {
    return (
        <div className='home-container'>
            <h1>Welcome Adventurer!</h1>
            <p>Prepare to enter the gates to start your journey...</p>
            <div>
                <Link to="/login"><button className="home-button">Login</button></Link>
                <Link to="/signup"><button className="home-button">Sign Up</button></Link>
            </div>
        </div>
    );
}

export default Home;